import React from "react";

const NotField: React.FC = props => {
    return <>{props.children}</>;
};

export default NotField;
